import { useContext } from "react";
import { StrategyContext } from "./context";

export const useStrategy = () => {
    const context = useContext(StrategyContext);

    if (context) {
        return context;
    }

    throw new Error(`useStrategyContext must be used within the context`);
};
